import { ReactElement, ReactNode } from "react";
import { Prompt } from "@ingka/modal";
import "@ingka/svg-icon/dist/style.css";
import "@ingka/button/dist/style.css";
import "@ingka/modal/dist/style.css";
import "@ingka/focus/dist/style.css";

interface PromptProps {
  title: ReactNode;
  titleId: string;
  header: ReactElement | null;
  footer: ReactElement | null;
  children: ReactNode;
  className?: string;
  "aria-labelledby"?: string;
}

export const FixaPrompt = (props: PromptProps) => {
  return <Prompt {...props} />;
};
